import React from 'react';
import _get from 'lodash/get';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function InstructionsRoute({ children, exact, path }) {
  const test = useSelector(state => state.test);
  const { usertype } = useSelector(state => state.auth.initUserDetails);
  const {
    is_onboarded,
    is_expired,
    slug: testSlug,
    invite_id,
    redirection_url,
    test_type,
    enable_feedback_page,
  } = test;
  const isCustomFormEnabled = _get(
    test,
    'settings.hacker_extra_data.custom_data.enabled'
  );

  let hasAccess = true;
  let redirectPath = `/test/${testSlug}/`;
  let search;
  if (is_expired === true && testSlug) {
    hasAccess = false;
    if (redirection_url) {
      window.location.href = redirection_url;
      return null;
    }
    if (test_type === 'LRN' && enable_feedback_page) {
      redirectPath = `/test-report/${testSlug}/`;
    } else {
      redirectPath = `/test/${testSlug}/feedback`;
    }
  } else if (
    is_expired === false &&
    isCustomFormEnabled === true &&
    is_onboarded === false &&
    testSlug &&
    usertype === 'hacker'
  ) {
    hasAccess = false;
    search = `?inviteId=${invite_id}`;
    redirectPath = `/${testSlug}/onboarding/form`;
  } // @Todo add onboarding check after this

  return (
    <Route
      exact={exact}
      path={path}
      render={props =>
        hasAccess ? (
          <>{children}</>
        ) : (
          <Redirect
            to={{
              pathname: redirectPath,
              search,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}
